'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _actionCreators = require('../../../store/actions/action-creators');

var _hudlVideoInterface = require('hudl-video-interface');

var insertPlayable = _hudlVideoInterface.viActions.insertPlayable,
    pause = _hudlVideoInterface.viActions.pause,
    play = _hudlVideoInterface.viActions.play,
    setPlayingIndex = _hudlVideoInterface.viActions.setPlayingIndex;


var THEATRE_PLAYER_ID = 'THEATRE_PLAYER';

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _state$theatre = state.theatre,
      feedContentId = _state$theatre.feedContentId,
      recommendations = _state$theatre.recommendations,
      sharedRecommendation = _state$theatre.sharedRecommendation;

  var player = state.players && state.players[THEATRE_PLAYER_ID] || {};
  var feedItem = state.feedItems && state.feedItems[feedContentId];
  var communityContentId = feedItem && feedItem.content.communityContentId;
  var selectedIndex = player && player.playingIndex || 0;
  var selectedRecommendation = recommendations && recommendations[selectedIndex].communityContentId;

  var currentUserId = state.userDetails.userId;
  if (!currentUserId && state.userDetails && state.userDetails.currentUser && state.userDetails.currentUser.details) {
    currentUserId = state.userDetails.currentUser.details.userId;
  }

  return {
    communityContentId: communityContentId,
    currentUserId: currentUserId,
    feedContentId: feedContentId,
    player: player,
    playerId: THEATRE_PLAYER_ID,
    recommendations: recommendations,
    selectedIndex: selectedIndex,
    selectedRecommendation: selectedRecommendation,
    sharedRecommendation: sharedRecommendation
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeTheatre: _actionCreators.closeTheatre,
    fetchCommunityContentMetadataIfNeeded: _actionCreators.fetchCommunityContentMetadataIfNeeded,
    getRecommendedVideos: _actionCreators.getRecommendedVideos,
    insertPlayable: insertPlayable,
    pause: pause,
    play: play,
    setPlayingIndex: setPlayingIndex,
    shareTheatreRecommendation: _actionCreators.shareTheatreRecommendation
  }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);